import React from 'react';
import propsComparator from '../../../utils/props-comparator';

import './TextField.scss';

export type TextChangeEvent = React.ChangeEvent<HTMLInputElement>;
export type TextChangeCallback = (event: TextChangeEvent) => void | null;

export interface TextFieldProps {
  type?: string;
  text?: string;
  hint?: string;
  style?: any;
  spellCheck?: 'true' | 'false';
  regex?: string | RegExp;
  onTextChange?: TextChangeCallback;
  autoFocus?: boolean;
}

export default class TextField extends React.Component<TextFieldProps> {

  state = {
    text: this.props.text ?? '',
    hint: this.props.hint ?? '',
    regex: this.props.regex ?? null,
    onTextChange: this.props.onTextChange
  }

  render() {
    return (
      <div className="text-field-component">
        <input
          spellCheck={this.props.spellCheck}
          type={this.props.type ?? 'text'}
          className=""
          value={this.state.text}
          placeholder={this.state.hint}
          onChange={this.onTextChange}
          style={{ background: '#ffffff', ...this.props.style }}
          {...(this.props.autoFocus ? { autoFocus: true } : {})}
        />
      </div>
    );
  }

  onTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let regex = this.state.regex;
    if (regex) {
      if (typeof regex === 'string') {
        regex = new RegExp(regex);
      }
      if (regex.test(event.target.value)) {
        return;
      }
    }
    this.setState({ text: event.target.value });
    if (this.state.onTextChange) {
      this.state.onTextChange(event);
    }
  }

  componentDidUpdate(prevProps: TextFieldProps) {
    const keys = Object.keys(this.state);
    const update = propsComparator(keys, prevProps, this.props) as any;
    if (update) {
      this.setState(update as any);
    }
  }

}
